import React from "react"
import propTypes from "prop-types"
import i18n from "i18n"
import { Switch } from "@mui/material"

const switchWrapperStyle = {
  width: "260px",
  marginBottom: "10px",
  position: "relative",
  marginLeft: "0px",
  height: "30px",
  backgroundColor: "#F3F3F3",
  borderRadius: "6px",
  display: "flex",
  paddingTop: "5px",
  paddingLeft: "15px",
}

const OptionSwitch = ({
  i18nKey,
  state,
  setState,
  inputKey,
  tipo,
  setDownloadBudgetConfig,
  disabled = false,
  onToggleBlocked = null,
}) => {
  return (
    <div style={switchWrapperStyle}>
      {i18n.t(i18nKey)}
      <div style={{ position: "absolute", right: "10px" }}>
        <Switch
          className="aaa"
          checked={state}
          disabled={disabled}
          onClick={() => {
            if (disabled) return

            if (!state && onToggleBlocked) {
              onToggleBlocked()
              return
            }

            setState(!state)
            setDownloadBudgetConfig(tipo, inputKey, !state)
          }}
          inputProps={{ "aria-label": "controlled" }}
          color="warning"
        />
      </div>
    </div>
  )
}

OptionSwitch.propTypes = {
  i18nKey: propTypes.string.isRequired,
  state: propTypes.bool.isRequired,
  setState: propTypes.func.isRequired,
  inputKey: propTypes.string.isRequired,
  tipo: propTypes.string.isRequired,
  setDownloadBudgetConfig: propTypes.func.isRequired,
  disabled: propTypes.bool,
  onToggleBlocked: propTypes.func,
}

export default OptionSwitch
